import { Layers, ShieldCheck, Sparkles, TrendingUp, Users, Zap } from "lucide-react";
import { Chapter, FadeUp } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [Sparkles, Layers, Zap, TrendingUp, ShieldCheck, Users];
const SPANS = ["sm:col-span-2", "", "", "", "sm:col-span-2", ""];

export default function WhyUs() {
  const { t } = useLanguage();
  const cards = t("why.cards");

  return (
    <section className="py-28 md:py-40" data-testid="why-us-section">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Chapter number="02" title={t("chapters.why")} />
        <FadeUp>
          <h2 className="mb-14 max-w-3xl text-balance font-syne text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-[3.4rem] md:mb-20" data-testid="why-us-heading">
            {t("why.heading")}
          </h2>
        </FadeUp>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((card, i) => {
            const Icon = ICONS[i];
            return (
              <FadeUp
                key={card.title}
                delay={i * 0.08}
                className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-[#111111] p-8 transition-[border-color,transform] duration-500 hover:-translate-y-1.5 hover:border-[#F97316]/50 md:p-10 ${SPANS[i]}`}
                data-testid={`why-us-card-${i + 1}`}
              >
                <span
                  className="pointer-events-none absolute -right-4 -top-8 font-syne text-[7rem] font-extrabold text-white/[0.04] transition-colors duration-500 group-hover:text-[#F97316]/10"
                  aria-hidden="true"
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <Icon className="h-6 w-6 text-[#F97316]" strokeWidth={1.5} />
                <h3 className="mt-8 font-syne text-xl font-bold tracking-tight md:text-2xl">{card.title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-relaxed text-white/50">{card.text}</p>
              </FadeUp>
            );
          })}
        </div>
      </div>
    </section>
  );
}
